module.exports = __webpack_public_path__ + "media/common/fonts/social/social-c26f54ab9f0b7859733283fc8c87c529.ttf";